module.exports = __webpack_public_path__ + "static/media/imgop_EPSRC-logo.7b7aeb69.jpg";